<template>
  <b-list-group-item>
    <div class="font-weight-bold text-primary">
      Tutar
    </div>
    <div
      class="font-weight-bolder font-medium-2"
      :class="dataModal.dataItem.is_expense === '1'? 'text-danger' : 'text-success'"
    >
      {{ dataModal.dataItem.is_income === '1'? '+' : '' }}{{ dataModal.dataItem.amount | toCurrency }} {{ dataModal.dataItem.currency }}
    </div>
  </b-list-group-item>
</template>
<script>
import { BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'Amount',
  components: {
    BListGroupItem,
  },
  computed: {
    dataModal() {
      return this.$store.getters['accountActivities/dataModal']
    },
  },
}
</script>
